import { useQueryClient } from "@tanstack/react-query";

/**
 * A wrapper hook for enabling & disabled queries, accounting for whether queries are disabled at the default option level.
 * If queries are disabled by default, this will return false regardless of the condition you supply.
 * If queries are enabled by default, this will check the condition you provide it.
 * @param condition Assuming queries are enabled by default, this is the next condition it will check. Can be a boolean or a callback function.
 */
export default function useIsQueryEnabled(condition: boolean | (() => boolean)): boolean {
  const queryClient = useQueryClient()

  if (queryClient.getDefaultOptions().queries?.enabled === false) {
    return false
  }

  return typeof condition === 'function' ? condition() : condition
}